export interface ShortcutDescriptor {
  id: string;
  key: string;
  description: string;
  group: string;
}

const shortcuts = new Map<string, ShortcutDescriptor>();
const listeners = new Set<() => void>();
let cachedSnapshot: ShortcutDescriptor[] = [];

function refreshSnapshot(): void {
  cachedSnapshot = Array.from(shortcuts.values());
}

function emit(): void {
  refreshSnapshot();
  listeners.forEach((l) => l());
}

export function registerShortcut(descriptor: ShortcutDescriptor): () => void {
  shortcuts.set(descriptor.id, descriptor);
  emit();
  return () => {
    if (shortcuts.get(descriptor.id) === descriptor) {
      shortcuts.delete(descriptor.id);
      emit();
    }
  };
}

export function getShortcuts(): ShortcutDescriptor[] {
  return cachedSnapshot;
}

export function subscribeToShortcuts(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
